import { fetchFleet, postFleetAction } from "../fleetApi";

export const qualityFleet = (params) => fetchFleet("quality/fleet", params);
export const qualityEpisodes = (projectId, params) => fetchFleet(`quality/agent/${projectId}/episodes`, params);
export const qualityEpisode = (episodeId) => fetchFleet(`quality/episode/${encodeURIComponent(episodeId)}`);
export const reviewQueue = (params) => fetchFleet("quality/review-queue", params);
export const reviewAgreement = (params) => fetchFleet("quality/agreement", params);
export const evalRuns = (params) => fetchFleet("quality/eval-runs", params);
export const agentDreams = (projectId, params) => fetchFleet(`quality/agent/${projectId}/dreams`, params);

export const labelReview = (verdictId, body) =>
  postFleetAction(`quality/review-queue/${encodeURIComponent(verdictId)}/label`, body);
export const revertDream = (projectId, date, agentId) =>
  postFleetAction(`quality/agent/${projectId}/dreams/${date}/revert`, {}, agentId ? { agent_id: agentId } : undefined);
export const revertDreamFacts = (projectId, date, agentId) =>
  postFleetAction(`quality/agent/${projectId}/dreams/${date}/revert-facts`, {}, agentId ? { agent_id: agentId } : undefined);
export const dreamPromotion = (projectId, agentId) => fetchFleet(`quality/agent/${projectId}/dreams/promotion`, { agent_id: agentId });
export const dreamPromotionImpact = (projectId, agentId) =>
  fetchFleet(`quality/agent/${projectId}/dreams/promotion/impact`, { agent_id: agentId });
export const promoteDream = (projectId, agentId) => postFleetAction(`quality/agent/${projectId}/dreams/promote`, {}, { agent_id: agentId });
export const unpromoteDream = (projectId, date, agentId) =>
  postFleetAction(`quality/agent/${projectId}/dreams/${date}/unpromote`, {}, { agent_id: agentId });
export const dreamReadiness = (params) => fetchFleet("quality/dreams/readiness", params);
export const dreamPromotions = (params) => fetchFleet("quality/dreams/promotions", params);
export const actionBacklog = (params) => fetchFleet("quality/dreams/action-backlog", params);
export const toolFailures = (params) => fetchFleet("quality/dreams/tool-failures", params);
export const agreementWeekly = (params) => fetchFleet("quality/agreement/weekly", params);
export const qualityByVersion = (params) => fetchFleet("quality/versions", params);
